import styled from "styled-components";

const Section = styled.div`
  margin-bottom: 48px;
  width: 100%;
`;

export default Section;
